import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { BannerInfoDTO } from '../dto/BannerManagementDTOs';
import { BannerType } from '../common/enums';
import { genNoobookHeader } from './Common';
import { NoobookFileInfoDTO } from '../dto/CommonDTOs';
//import { NoobookUtils } from '../utils/NoobookUtils';



export function getBannerForUser(authToken:string, bannerType:BannerType):Promise<ResponseDTO<BannerInfoDTO[]>>{
	return ApiComm.getData<ResponseDTO<BannerInfoDTO[]>>(`/close/v1/banner/bannerType/${bannerType}`
		, {}
		, genNoobookHeader(authToken, null, 'application/json', 'app')
	).then(resp=>resp.data);
}





